/**
 * Packages & Services builder — shared form primitives. Extracted
 * verbatim from the former AgencyServicesPage monolith (Task 150-A).
 * No behavior change. (The only adjustment is a type-only import:
 * `React.ReactNode` → an explicit `ReactNode` import; identical type.)
 */

import type { ReactNode } from 'react';

export function FormPanel({
  title,
  children,
}: {
  readonly title: string;
  readonly children: ReactNode;
}) {
  return (
    <div
      className="card"
      style={{
        marginTop: 14,
        padding: 18,
        background: 'var(--cream-2)',
        border: '1px dashed var(--line-2)',
      }}
    >
      <div className="sec-title" style={{ marginBottom: 8 }}>
        <h2 style={{ fontSize: 16 }}>{title}</h2>
      </div>
      {children}
    </div>
  );
}

export function SimpleField({
  label,
  value,
  onChange,
  required,
  type,
  placeholder,
  maxLength,
  dirLtr,
  textarea,
}: {
  readonly label: string;
  readonly value: string;
  readonly onChange: (v: string) => void;
  readonly required?: boolean;
  readonly type?: 'text' | 'number';
  readonly placeholder?: string;
  readonly maxLength?: number;
  readonly dirLtr?: boolean;
  readonly textarea?: boolean;
}) {
  return (
    <div className="auth-field" style={{ marginBottom: 0 }}>
      {label.length > 0 ? (
        <label className="auth-field-label">
          {label}
          {required ? ' *' : ''}
        </label>
      ) : null}
      {textarea ? (
        <textarea
          className="auth-input"
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          rows={2}
          style={{ paddingInlineStart: 18, resize: 'vertical' }}
        />
      ) : (
        <input
          className="auth-input"
          type={type ?? 'text'}
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          dir={dirLtr ? 'ltr' : undefined}
          style={{ paddingInlineStart: 18 }}
        />
      )}
    </div>
  );
}

export function SimpleSelect({
  label,
  value,
  onChange,
  required,
  options,
}: {
  readonly label: string;
  readonly value: string;
  readonly onChange: (v: string) => void;
  readonly required?: boolean;
  readonly options: ReadonlyArray<{ readonly value: string; readonly label: string }>;
}) {
  return (
    <div className="auth-field" style={{ marginBottom: 0 }}>
      {label.length > 0 ? (
        <label className="auth-field-label">
          {label}
          {required ? ' *' : ''}
        </label>
      ) : null}
      <select
        className="auth-input"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        style={{ paddingInlineStart: 18 }}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
